import React, { memo } from 'react'
import { OnboardingAddressFields } from '../OnboardingAddressFields'

const BUSINESS_ADDRESS_FIELDS = {
  addressLine1: 'businessAddressLine1',
  addressLine2: 'businessAddressLine2',
  city: 'businessCity',
  state: 'businessState',
  zipCode: 'businessZipCode',
  country: 'businessCountry',
}

const BusinessAddressStepComponent = () => {
  return <OnboardingAddressFields fieldNames={BUSINESS_ADDRESS_FIELDS} />
}

export const BusinessAddressStep = memo(BusinessAddressStepComponent)
